import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('mismo-studio');

const MismoStudioPage = () => <CaseStudyPage project={project} />;

export default MismoStudioPage;
